document.addEventListener('DOMContentLoaded', function () {
    "use strict";

    const tabButtons = document.querySelectorAll('.zwssgr-tab-button');
    const tabContents = document.querySelectorAll('.zwssgr-tab-content');

    tabButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            const tab = this.getAttribute('data-tab');

            // Update buttons
            tabButtons.forEach(function(btn) {
                btn.classList.remove('active');
            });
            this.classList.add('active');

            // Update content
            tabContents.forEach(function(content) {
                content.classList.remove('active');
            });
            const targetContent = document.getElementById(tab + '-tab');
            if (targetContent) {
                targetContent.classList.add('active');
            }
        });
    });
});